import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  BasketNeedPolicy,
  SmartBasketComparison,
  SmartNeedResolution,
  SmartResolutionType
} from '@core/models/models';

@Component({
  selector: 'app-price-comparison-view',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './price-comparison-view.component.html',
  styleUrl: './price-comparison-view.component.css'
})
export class PriceComparisonViewComponent {
  @Input() comparison: SmartBasketComparison | null = null;
  @Input() busyNeedIds: Set<number> = new Set<number>();
  @Input() profileBusy = false;
  @Input() compareLoading = false;

  @Output() approve = new EventEmitter<SmartNeedResolution>();
  @Output() lock = new EventEmitter<SmartNeedResolution>();

  formatMoney(value: number | null | undefined, currency: string = '₪'): string {
    if (value === null || value === undefined || Number.isNaN(value)) {
      return '—';
    }
    const symbol = currency === 'ILS' || currency === '₪' ? '₪' : currency;
    return `${symbol}${value.toFixed(2)}`;
  }

  formatPercent(value: number | null | undefined): string {
    if (value === null || value === undefined || Number.isNaN(value)) {
      return '';
    }
    return `${Math.round(value * 100)}%`;
  }

  resolutionLabel(type: SmartResolutionType | null): string {
    switch (type) {
      case 'locked':
        return 'מוצר נעול';
      case 'approved':
        return 'חלופה שאושרה';
      case 'semantic':
        return 'הצעת התאמה חכמה — טרם אושרה';
      case 'catalog':
        return 'הצעת קטלוג — טרם אושרה';
      case null:
        return 'לא נמצא מוצר';
    }
  }

  needPolicyLabel(policy: BasketNeedPolicy): string {
    switch (policy) {
      case 'exact':
        return 'מוצר מדויק';
      case 'approved':
        return 'חלופות שאושרו';
      case 'best_value':
        return 'התמורה הטובה ביותר';
    }
  }

  confidenceLabel(confidence: number | null | undefined): string {
    if (confidence === null || confidence === undefined) {
      return '—';
    }
    return `${Math.round(confidence * 100)}%`;
  }

  hasUnapprovedSuggestions(resolutions: SmartNeedResolution[]): boolean {
    return resolutions.some((r) => r.approvalRequired);
  }
}
